import { application } from "./application"
import CodeBlockController from "./code_block_controller"
import EnquiryFormController from "./enquiry_form_controller"

application.register("code-block", CodeBlockController)
application.register("enquiry-form", EnquiryFormController)
